import { getAPIBaseURL } from "@/env";

export const HEALTH_CHECK_URL = "/health-check";

export const HOME_URL = "/";
export const PROJECTS_URL = "/projects";
export const PROJECT_URL = `${PROJECTS_URL}/:projectId`;
export const NEW_SUB_TASK_URL = "/projects/:project_id/new_sub_task";
export const ASSET_FILES_URL = "/projects/:project_id/files";
export const LOGIN_URL = "/login";
export const SIGNUP_URL = "/signup";
export const FORGOT_PASSWORD_URL = "/forgot-password";

export const DASHBOARD_URL = "/dashboard";

export const ASSISTANT_URL = "/assistant";
export const PROJECT_ASSISTANT_URL = `${PROJECT_URL}${ASSISTANT_URL}`;
export const PROJECT_DASHBOARD_URL = `${PROJECT_URL}${DASHBOARD_URL}`;

export const PENDING_URL = "/pending/:tab";
export const PROJECT_PENDING_URL = `${PROJECT_URL}${PENDING_URL}`;
export const PROJECT_PENDING_BID_PACKAGE_URL = `${PROJECT_URL}/pending/:bidPackageId/:tab`;
export const PROJECT_PENDING_DETAIL_URL =
  "/projects/:project_id/pending/:bid_package_id/:tab";

export const ASSIGNED_URL = "/assigned";
export const PROJECT_ASSIGNED_URL = "/projects/:project_id/assigned";
export const PROJECT_ASSIGNED_DETAIL_URL =
  "/projects/:project_id/assigned/:turnover_id";

export const COMPLETED_URL = "/completed";
export const PROJECT_COMPLETED_URL = "/projects/:project_id/completed";
export const PROJECT_COMPLETED_DETAIL_URL =
  "/projects/:project_id/completed/:vendor_delivery_id";
export const INVOICED_URL = "/invoices";
export const PROJECT_INVOICES_URL = "/projects/:project_id/invoices";
export const PROJECT_INVOICE_URL = "/projects/:project_id/invoices/:invoice_id";
export const PROJECT_DELIVERY_CHECK_URL =
  "/projects/:project_id/name-validator";

export const INVOICE_PDF_URL =
  "/projects/:project_id/invoices/:invoice_id/hotspring/pdf";
export const MEDIA_SHUTTLE_URL = "/media_shuttle/:media_shuttle_id/:link_id";

export const MANAGE_EC2_INSTANCES = "/manage-instances";

// Company Chat
export const COMPANY_CHAT_URL = "/projects/:project_id/company/:company_id";

// Supervisor Routes
export const SUPERVISOR_ASSIGNED_URL = "/assigned-tasks";

// Artist Routes
export const USER_ASSIGNED_URL = "/assigned-tasks";
export const USER_DELIVERY_URL = "/deliver";
export const USER_PROJECT_ASSIGNED_URL = "/projects/:project_id/assigned-tasks";
export const USER_PROJECT_DELIVERY_URL = "/projects/:project_id/deliver";

export const NEW_TASK_URL = "/projects/:project_id/new_task";
export const ACTIONS_URL = `${PROJECT_URL}/actions/:action`;

// Update Menu Routes
export const EDIT_SOURCE_MEDIA_URL = "/projects/:project_id/edit/source_media";
export const EDIT_PROJECT_REFERENCES_URL =
  "/projects/:project_id/edit/references";
export const EDIT_PROJECT_DEADLINE_URL = "/projects/:project_id/edit/deadline";
export const EDIT_PROJECT_SPECS_URL = "/projects/:project_id/edit/specs";
export const EDIT_PROJECT_CORRECTIONS_URL =
  "/projects/:project_id/edit/corrections";

// Bid Method Selection
export const CUSTOM_BID = "/projects/:project_id/new_task/custom_bid";
export const FLASH_BID = "/projects/:project_id/new_task/flash_bid";

// Financial Dashboard
export const FINANCIAL_DASHBOARD_URL = "/financial-dashboard";

// API urls
export const SAMPLE_CSV_URL = `${getAPIBaseURL()}/sample-csv/:bid_package_id/export`;
export const BID_PACKAGE_GENERATE_CSV_API_URL = `${getAPIBaseURL()}/bid-package/:bid_package_id/export`;
export const DESCRIPTION_CSV_URL = `${getAPIBaseURL()}/ts-description-csv/:task_shot_ids/export`;
export const FEEDBACK_NOTE_CSV_URL = `${getAPIBaseURL()}/feedback-note-csv/:task_shot_ids/export`;
export const RENAME_SHOT_CSV_URL = `${getAPIBaseURL()}/rename-shot-csv/:vendor_delivery_id/export`;

export const buildUrl = (url: string, params: { [key: string]: string }) => {
  let updatedUrl = url;
  Object.keys(params).forEach((key) => {
    updatedUrl = updatedUrl.replace(`:${key}`, params[key]);
    return updatedUrl;
  });
  return updatedUrl;
};

export function getFilterFromParams<T = string>(
  params: URLSearchParams,
  key: string,
  fallbackValue?: T,
) {
  const value = params.get(key);

  if (value !== null) return value as unknown as T;

  return fallbackValue ?? null;
}

export function getBooleanFilterFromParams(
  params: URLSearchParams,
  key: string,
) {
  return getFilterFromParams(params, key) === "true";
}

/**
 * Return the closest matching URL from an enum (from the leaf).
 * For example, if URL_ENUM = { ASSIGNED: "assigned", ASSIGNED_TURNOVER: "turnover" },
 * With pathname="/assigned/turnover/1234" => returns turnover
 * With pathname="/turnover/assigned" => returns assigned
 */
export const getPageUrl = <T>(pathname: string, URL_ENUM: object) => {
  const urlSegments = pathname.split("/").reverse();
  const urlEnumValues = Object.values(URL_ENUM);
  return urlSegments.find((urlSegment) =>
    urlEnumValues.includes(urlSegment),
  ) as unknown as T;
};
